<template>
  <v-hover v-slot="{ isHovering, props: hoverProps }">
    <qtm-icon-btn
      v-bind="mergeProps($attrs, hoverProps)"
      :color="isHovering ? 'error' : 'mid-light-grey'"
      :icon="icon"
    />
  </v-hover>
</template>

<script setup lang="ts">
import { mergeProps } from 'vue'

defineOptions({ inheritAttrs: false })

export interface Props {
  icon?: string
}

withDefaults(defineProps<Props>(), {
  icon: 'mdi-trash-can-outline',
})
</script>
